import logo from '@/assets/al_flow_login.svg';
import Footer from '@/components/Footer/footer';
import Constants from '@/Constants';
import { redirectToStore } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import React, { useEffect } from 'react';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { GoToAppOrStoreImage } from '../GoToAppOrStoreImage';
import './styles.scss';

export interface BtnConfig {
    label: string;
    action: () => void;
}

interface Props {
    autoRedirect?: boolean;
    customBtnConfig?: BtnConfig;
}

const GoToAppOrStoreStandard: React.FC<Props> = (props: Props) => {
    const { autoRedirect, customBtnConfig } = props;

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const onClickHandler = () => {
        if (customBtnConfig?.action) {
            return customBtnConfig.action();
        }
        return redirectToStore(isIOS);
    };

    useEffect(() => {
        if (autoRedirect) {
            if (isMobileOnly && (isAndroid || isIOS)) {
                isAndroid && setTimeout(() => redirectToStore(isIOS), 2000);

                window.location.href = Constants.mobileApp.APP_HOME_DEEP_LINK;
            }
        }
    }, [autoRedirect]);

    return (
        <div className="goto-app-or-store-container">
            <img alt={`${strings.LOGO_OF_COMPANY} Afferolab.flow`} className="org-logo-img" src={logo} />

            <div className="image-decoration-container">
                <GoToAppOrStoreImage color="#EB0045" />
            </div>

            <div className="information-text-container">
                <h4>{strings.GO_TO_APP_OR_STORE_TITLE}</h4>
                <span>{strings.GO_TO_APP_OR_STORE_DESCRIPTION}</span>
            </div>

            <button className="btn btn-primary btn-block store-button" onClick={onClickHandler} type="button">
                {customBtnConfig?.label || strings.CLICK_TO_DOWLOAD_APP}
            </button>

            <Footer />
        </div>
    );
};

export { GoToAppOrStoreStandard };
